import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wc-web-ads-container px-0"
}

import { computed } from 'vue';
import { SplideSlide } from '@splidejs/vue-splide';
import WebAd from '@/models/entities/web-ad';
import usePlatform from '@/modules/platform/composables/usePlatform';
import WCWebAdModern from '../WCWebAdModern/WCWebAdModern.vue';
import WCAutoplayCarouselModern from '../WCAutoplayCarouselModern/WCAutoplayCarouselModern.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCWebAdsModern',
  props: {
    webAds: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const { platform } = usePlatform();

const mobileWebAds = computed(() => props.webAds.filter(webAd => webAd.type === 2));
const desktopWebAds = computed(() => props.webAds.filter(webAd => webAd.type === 1));

const isDesktopOrTablet = computed(() => !platform.value.isMobile || platform.value.isMediumDevice);

const visibleWebAds = computed(() => {
  if (isDesktopOrTablet.value && desktopWebAds.value.length > 0) {
    return desktopWebAds.value.slice(0, 6);
  }
  if (platform.value.isMobile && mobileWebAds.value.length > 0) {
    return mobileWebAds.value.slice(0, 6);
  }

  return props.webAds.slice(0, 6);
});

return (_ctx: any,_cache: any) => {
  return (visibleWebAds.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (visibleWebAds.value.length == 1)
          ? (_openBlock(), _createBlock(WCWebAdModern, {
              key: 0,
              "web-ad": visibleWebAds.value[0]
            }, null, 8, ["web-ad"]))
          : (_openBlock(), _createBlock(WCAutoplayCarouselModern, {
              key: 1,
              class: "px-0 position-relative"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleWebAds.value, (webAd) => {
                  return (_openBlock(), _createBlock(_unref(SplideSlide), {
                    key: webAd.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(WCWebAdModern, { "web-ad": webAd }, null, 8, ["web-ad"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
      ]))
    : _createCommentVNode("", true)
}
}

})